<template>
    <div class="backbtn" @click="fanhui()">
        <img src="../../assets/images/backicon.png" alt="">
    </div>
</template>

<script>
export default {
    components: {
    },
    name: 'floatback',
    data() {
        return {

        }
    },
    computed: {
    },
    created() {
        document.title = "ACMED第一届学术年会";
    },
    beforeDestroy() {

    },
    methods: {
        fanhui() {
            this.$router.push({ name: 'ACMED' })
        }
    }
}
</script>

<style lang="scss" scoped>
.backbtn {
    width: 13%;
    position: fixed;
    right: 0;
    top: 50%;
    opacity: .8;
    transform: translateY(-50%);
}

.backbtn {
    img {
        width: 100%;
    }
}
</style>